module.exports = __webpack_public_path__ + "img/thunderstorm.01e2a454.svg";